import { render, staticRenderFns } from "./TicketAttentionDialog.vue?vue&type=template&id=f6230cb6"
import script from "./TicketAttentionDialog.js?vue&type=script&lang=js&external"
export * from "./TicketAttentionDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports